<template>
  <div id="app">
  <section class="hero is-primary is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1>Kevin J Bayer</h1>
            <h2>Full Stack Developer</h2>
            <h2>dba Atech Studio / Architechnology, Inc.</h2>
          </div>
          <div class="column">
            <h2 class="is-pulled-right"><a href="mailto:kevin@atechstudio.com" class="email">kevin@atechstudio.com</a></h2><br>
            <h2 class="is-pulled-right">New Orleans / Cincinnati</h2><br>
            <!-- <h2 class="is-pulled-right">STATUS: Not accepting projects</h2><br> -->
            <div class="is-pulled-right">
              <a href="http://twitter.com/kevinjbayer" target="_blank" class="social"><i class="fa fa-twitter"></i></a>
              <a href="http://github.com/kevinjbayer" target="_blank" class="social"><i class="fa fa-github"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10 is-offset-1">

          <h3>Current</h3>

          <div class="columns is-gapless">
            <div class="column is-one-third" style="background-color: #199bea">
                <figure class="image">
                  <a href="https://caketoage.com" target="_blank"><img src="./assets/Cake-to-Age-Hold-Still,-Lion-600.png" style="" class="is-paddingless" alt=""></a>
                </figure>
            </div>
            <div class="column is-two-thirds" style="background-color: white;">
              <div class="project-description">
                <h3 class="project-title" style="margin-bottom: 5px;">
                  <a href="https://caketoage.com" target="_blank" class="project-link">Cake To Age</a> - Hold Still, Lion album
                </h3>
                <p>11 track electronic album that I released in Oct 2020. Lots of samples. Lots of heart. There's a story in there if you let it settle.

                  <br><br>
                  <a href="https://open.spotify.com/album/75Q6TYAoeMdoAKzAKolNrR?si=wJQTq_r4SfWbQxOKGgoaIg" target="_blank">Spotify</a><br>
                  <a href="https://l.facebook.com/l.php?u=https%3A%2F%2Fmusic.apple.com%2Fus%2Falbum%2Fhold-still-lion%2F1536755481%3Fuo%3D4%26app%3Dmusic%26at%3D1001lry3%26ct%3Ddashboard%26fbclid%3DIwAR0QKa6nB0y1lEQsdEJzk19mlXhWFOtc8qXshDrPRxMLIgTBK5KUKG9ttbw&h=AT3NDy7mcftrcYyvsvK0HWJcv9Begcn7k5G6zuA1JWoZZzN5_S6ykpMiUctKjQ0ZfZOUe13KvI0lIHQv1Mm6tzmM7G4xaQ7N5Ti_ynhpT61N9HjbV57JNkZ-B4ENoPOJ2Z2rxCO28A&__tn__=R]-R&c[0]=AT2ujKPvVcL2ayYu_37NrVHadbs3eOjcY4oDeBqYD9ODgIt3y2yuLCFtKkYxvDI_a1AljlgQ-RT1rlu8z63ahm1bcIrvqXAbIPXuNPFEC8XrOAbCdmwxrD3X3S5FgDZT4YpYuM91me7rGIl9t_JTT6uT" target="_blank">Apple Music</a><br>
                  <a href="https://caketoage.bandcamp.com/album/hold-still-lion" target="_blank">Bandcamp</a>
                </p>
              </div>
            </div>
          </div>

          <div class="columns is-gapless">
            <div class="column is-one-third" style="background-color: #199bea">
                <figure class="image">
                  <a href="http://welcometocollege.com" target="_blank"><img src="./assets/wtc.jpg" style="max-width: 500px;" class="is-paddingless" alt=""></a>
                </figure>
            </div>
            <div class="column is-two-thirds" style="background-color: white;">
              <div class="project-description">
                <h3 class="project-title" style="margin-bottom: 5px;">
                  <a href="http://welcometocollege.com" target="_blank" class="project-link">Welcome To College</a> - Full Stack
                  Developer
                </h3>
                <p>I develop and maintain this website that encapsulates all aspects of the campus visit, including visit
                  registrations and ambassador management.</p>
              </div>
            </div>
          </div>

          <div class="columns is-gapless">
            <div class="column is-one-third" style="background-color: #962924;">
              <figure class="image">
                <a href="http://youyoureawesome.bandcamp.com" target="_blank"><img src="./assets/yya.jpg" style="max-width: 500px;" class="is-paddingless" alt=""></a>
              </figure>
            </div>
            <div class="column is-two-thirds" style="background-color: white;">
              <div class="project-description">
                <h3 class="project-title" style="margin-bottom: 5px;">
                  <a href="http://youyoureawesome.bandcamp.com" target="_blank" class="project-link">You, You're Awesome</a> -
                  Drums</h3>
                <p>Electronic Soul duo is the best way to describe this band. We began in 2008 and we released our most recent
                  album 'You're Evil & That's OK' in Aug
                  2016. Working on new music in 2021.</p>
              </div>
            </div>
          </div>

          <!--<div class="columns is-gapless">-->
            <!--<div class="column is-one-third" style="background-color: #4a2021;">-->
              <!--<figure class="image">-->
                <!--<a href="http://therighteousroom.com/" target="_blank"><%# image_tag 'rr.jpg', class: 'is-paddingless' %></a>-->
              <!--</figure>-->
            <!--</div>-->
            <!--<div class="column" style="background-color: white;">-->
              <!--<div class="container project-description">-->
                <!--<h3 class="project-title" style="margin-bottom: 5px;">-->
                  <!--<a href="http://therighteousroom.com/" target="_blank" class="project-link">The Righteous Room</a> - -->
                  <!--DJ Residency</h3>-->
                <!--<p>Since 2009, Yusef Quotah and I have held a DJ residency at this venue on Sunday nights. We switched to vinyl-->
                  <!--only in 2015. Listen to a mix below.</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->



        </div>
      </div>
    </div>
  </section>

  <section class="section bottom">
    <div class="container">
      <div class="columns">

        <div class="column">
          <h3>Technical Experience</h3>
          <ul>
            <li>7+ years Ruby on Rails</li>
            <!-- <li>< 1 year Elixir &amp; Phoenix</li> -->
            <li>15+ years PHP (Wordpress, ExpressionEngine)</li>
            <li>Databases: PostgreSQL, MySQL, Redis</li>
            <li>Front-End: HTML, CSS, Javascript, Vue</li>
            <li>DevOps: Heroku, WHM/cPanel</li>
          </ul>


        </div>

        <div class="column">

          <h3>worked on/with:</h3>
          <ul>
            <li><a href="http://www.creativesoncall.com/" target="_blank">Creatives On Call</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li>
            <!-- <li><a href="http://www.creativedepartment.com/" target="_blank">The Creative Department</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li> -->
            <!-- <li><a href="http://www.danielmartinmoore.com" target="_blank">Daniel Martin Moore</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li> -->
            <li><a href="https://www.youtube.com/watch?v=pfpXLu62hGE" target="_blank">Frightened Rabbit / Sub Pop</a>
              <span style="color: #5d636c; margin-left:15px;">Video</span></li>
            <li><a href="http://www.grote.com" target="_blank">Grote</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="http://www.makercreative.com" target="_blank">Maker Creative</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="http://www.monasterystudio.com" target="_blank">Monastery Studio</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <!-- <li><a href="http://www.phratryrecords.com" target="_blank">Phratry Records</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li> -->
            <li><a href="http://www.salesforce.com" target="_blank">Salesforce</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="http://www.wehavebecomevikings.com" target="_blank">We Have Become Vikings</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li>
            <li><a href="https://vimeo.com/1478933" target="_blank">WOXY (RIP)</a>
              <span style="color: #5d636c; margin-left:15px;">Video</span></li>
          </ul>

        </div>

        <div class="column">

          <h3>DJ Mix</h3>

          <p style="color:#999999;">All vinyl mix from Cincinnati 2016.</p>
          <br>

          <iframe width="100%" height="120" src="https://www.mixcloud.com/widget/iframe/?feed=https%3A%2F%2Fwww.mixcloud.com%2Fkevinjbayer%2Frighteous-room-9252016%2F&hide_cover=1" frameborder="0"></iframe>


          <!-- <h3>worked on/with:</h3>
          <ul>
            <li><a href="http://www.creativedepartment.com/" target="_blank">The Creative Department</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li>
            <li><a href="http://www.danielmartinmoore.com" target="_blank">Daniel Martin Moore</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="https://www.youtube.com/watch?v=pfpXLu62hGE" target="_blank">Frightened Rabbit / Sub Pop</a>
              <span style="color: #5d636c; margin-left:15px;">Video</span></li>
            <li><a href="http://www.makercreative.com" target="_blank">Maker Creative</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li>
            <li><a href="http://www.monasterystudio.com" target="_blank">Monastery Studio</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="http://www.phratryrecords.com" target="_blank">Phratry Records</a>
              <span style="color: #5d636c; margin-left:15px;">Web Development</span></li>
            <li><a href="http://www.wehavebecomevikings.com" target="_blank">We Have Become Vikings</a>
              <span style="color: #5d636c; margin-left:15px;">Freelance</span></li>
            <li><a href="https://vimeo.com/1478933" target="_blank">WOXY (RIP)</a>
              <span style="color: #5d636c; margin-left:15px;">Video</span></li>
          </ul> -->

        </div>

        <!-- <div class="column">
          <h3>Records</h3>
          <div class="columns is-mobile is-multiline">
            <% @records.each do |album| %>
              <div class="column is-one-quarter-mobile is-one-third-desktop is-one-third-tablet is-marginless is-paddingless">
                <figure class="image">
                  <%= link_to image_tag(album.basic_information.thumb, class: ''), @wrapper.get_release(album.basic_information.id).uri, target: '_blank' %><%# album.basic_information.id %>
                </figure>
                <br>
                <%# @wrapper.get_release(album.basic_information.id).uri %>
              </div>
            <% end %>
          </div>
        </div> -->

        <!-- <div class="column">
          <% if @posts.present? %>
            <h3>Browsing</h3>
            <ul style="margin-top: -18px;">
              <% @posts.each do |post| %>
                <li><%# post %><br><%= link_to post.description, post.href, target: '_blank' %><br><%= post.extended %></li>
              <% end %>
            </ul>
          <% end %>
        </div> -->

      </div>
    </div>
  </section>
</div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "app",
  components: {
    HelloWorld
  }
};
</script>

<style lang="scss">
#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  // margin-top: 60px;
}
</style>
